import { useEffect } from "react";

interface SeoProps {
  title: string;
  description?: string;
  keywords?: string;
}

export default function useSeo({ title, description, keywords }: SeoProps) {
  useEffect(() => {
    document.title = title;
    if (description) {
      let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }
      meta.content = description;
    }
    if (keywords) {
      let meta = document.querySelector<HTMLMetaElement>('meta[name="keywords"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "keywords";
        document.head.appendChild(meta);
      }
      meta.content = keywords;
    }
  }, [title, description, keywords]);
}